import { DEFAULT_GETTERS } from '@/modules/sale/constants';

export default {
  ...DEFAULT_GETTERS,
  cart: (state) => state.cart,
  checkDuplicateOrder: (state) => state.checkDuplicateOrder,
  finishOrder: (state) => state.finishOrder
};
